import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { YesNoRendererComponent } from '../../../../../common/components/yes-no-renderer.component'

export default function TenantDetailsComponent ({businessDetails}: any) {
  return (
    <>
  
  <AccordionContainer
      child={
          <div className="h-auto w-full bg-white  p-4 rounded">
          <table className="w-full text-xs bg-red-50">
              <thead className="w-full border-y border-black border-opacity-20">
                  <tr className="w-full text-left h-12">
                      <th className="px-3">S.NO</th>
                      <th className="px-3">TenantName</th>
                      <th className="px-3">Host</th>
                      <th className="px-3">Active</th>
                      <th className="px-3">SoftwareBuildUpdateRequried</th>
                      <th className="px-3">TenantDefaultValuesUpdateRequried</th>
                  </tr>
              </thead>
              <tbody className="w-full h-auto">
                  {businessDetails?.Tenants?.map((TranscationItems: any, index: any) => (
                      <tr key={index} className="cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
                          <td className="px-3">{index + 1}</td>
                          <td className="px-3">{TranscationItems?.TenantName}</td>
                          <td className="px-3">{TranscationItems?.Host}</td>
                          <td className="px-3"> <YesNoRendererComponent
                                        value={TranscationItems?.IsActive}/></td>
                          <td className="px-3"><YesNoRendererComponent
                                        value={TranscationItems?.IsSoftwareBuildUpdateRequried}/></td>
                                        <td className="px-3"><YesNoRendererComponent
                                        value={TranscationItems?.IsTenantDefaultValuesUpdateRequried}/></td>
                      </tr>
                  ))}
              </tbody>
          </table>
      </div>
     }
     expandedPanel="Tenant Details"
     headerTitle="Tenant Details"
   />    
    </>
  )
}